<template>
    <div>
      <!-- <div class="vx-card__title">
        <figure class="IB_logo" v-if="checkProperty(getTenantLogo, 'logo')"><a href="#"><img
              :src="getTenantLogo['logo']"></a></figure>
        <figure class="IB_logo IB_logoDefault" v-else><a href="https://immibox.com/" target="_blank"><img
              :src="logoPath"></a></figure>
      </div> -->
       <template v-if="authType=='options'">
      <form @submit.prevent data-vv-scope="requestForm" @click="requestErr= ''">   
         <div class="form-container">
            <div class="mfa_process"  >
              <h4 class="title">Multi-Factor Authentication set up</h4>
              <p class="paragraph">Please select one of the available authentication methods below and follow the instructions.</p>
                <!-- <p><strong>Prerequisite for Email:</strong> If you wish to set up MFA Authentication via Email. Input the 4-digit OTP sent to your email. Ensure to validate and verify the OTP.</p> -->
                <!-- <p><strong>Prerequisite for Authenticator App:</strong> If you prefer to use an Authenticator app for MFA Authentication, you need to have the Authenticator mobile app installed on your phone.</p> -->
            <!-- <ul class="process_list">
                <li>Open the Authenticator app and select the ‘Scan a QR code’ option. Scan the QR code displayed on your application screen. The Authenticator app will start generating a 6-digit OTP number that changes every 30 seconds. Input the 6-digit OTP. Ensure to validate and verify the OTP.</li>
                <li>In the future, enter the 6-digit OTP displayed in your Authenticator app and click the ‘Verify’ button. With Multi-Factor Authentication enabled, you will be granted access only after entering the valid 6-digit OTP.</li>
                <li>Ensure that the Authenticator app is open and running while logging in with MFA.</li>
            </ul> -->
             
               <!-- <li> 
                 <vs-radio   vs-name="selectProcess" @input="setMfaProcess('email')" :vs-value="'email'" v-model="selectedAuthType" class="w-full" >Email</vs-radio>
               </li>
               <li>
                 <vs-radio  vs-name="selectProcess" @input="setMfaProcess('authenticator')" :vs-value="'authenticator'"  v-model="selectedAuthType" class="w-full" >Authenticator App</vs-radio>
               </li> -->
               <!-- primary-btn -->
                <div class="gap-2 d-flex justify-center align-items-center">
               <vs-button class="md mb-4" @click="setMfaProcess('email')">Email Enable</vs-button>
               <vs-button class="md mb-4" @click="setMfaProcess('authenticator')">Authenticator App Enable</vs-button>
            </div>
             <input  type="hidden" :name="'select_Process'" :key="'select_Process'" v-validate="'required'" data-vv-as="Field"  v-model="selectedAuthType">
             <span class="text-danger text-sm"   
             v-show="errors.has('requestForm.select_Process')">{{ errors.first('requestForm.select_Process')}}</span>
          
          
           
            <p v-if="authType=='options'" class="paragraph">
              Multi-Factor Authentication adds an additional layer of security to your account by requiring an extra verification step after you enter your username and password.
            </p>
          </div>
          </div>
          <div class="popup-footer relative flex-column border-0 px-0 h-auto mt-4">
            <figure  class="loader" v-if="loading"> <img src="@/assets/images/main/loader.gif" />  </figure>
            <!-- <vs-button  class="primary-btn w-full" :disabled="loading" type="filled" @click="selectMfaMethod()">Submit</vs-button> -->
            <a v-if="checkProperty(mfaDetails, 'gracePeriodInDays') && reminder" class="remaind_later  mb-1"  @click="showReminder">Remind me later </a>
        </div>
      </form>
      </template>
      <template v-if="authType=='email'">
        <div class="v-modal verification_modal mfa_auth">
          <form @submit.prevent data-vv-scope="verificationForm" @click="otpErrorMsg= ''" >
            <div class="form-container text-center" @click="otpErrorMsg=''">
              <div class="verification_info"> 
                  <h6 class="otp_verify">Validate your Email</h6>
                  <p>A One-Time 4 digits OTP has been sent to <span class="verify_email">{{ formattedEmail }}</span></p>
              </div>
              <div class="otp_filed otp_four_digits d-flex justify-center">
                <otpInput :isDisabled="isDisabled"  v-model="otpVal" @input="updateOtpVal" :length="4" :wrapclass="'md:w-1/4'"  :showLabel="false" :fieldName="'otp'" :cid="'otp'" />
                <input type="hidden" :name="'primaryDocs'" v-validate="'required'"  data-vv-as="Field"  v-model="getOtpVal">
                <span  v-show="errors.has( 'verificationForm'+'.primaryDocs')" class="text-danger text-sm">*OTP is required</span>
              </div>
              <template v-if="!isDisabled">
              <span v-if="resendTimer" class="otp_timer mt-3">Resend OTP in <b>{{ resendTimer }}s</b></span>
              <span v-else class="mt-3 otp_timer">Didn't receive the OTP? <br> <span @click="resendOtp()" class="resend_btn"> Resend</span> </span>
             </template>
              <div class="text-danger text-sm formerrors custom_margin" v-show="otpErrorMsg">
                  <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                  icon="IP-information-button" active="true">{{ otpErrorMsg }}</vs-alert>
              </div>
            </div>
            <div class="popup-footer relative">
                  <figure  class="loader" v-if="loading"> <img src="@/assets/images/main/loader.gif" />  </figure>
                  <!-- <vs-button v-if="mfaSettingUp" class="w-full primary-btn mb-2" :disabled="loading" type="filled" @click="validate('email')">Validate</vs-button> -->
                  <!-- primary-btn -->
                  <vs-button  class="" :disabled="loading" type="filled" @click="submitMfa()">Next</vs-button>
                <template v-if="!mfaSettingUp && !fromEditEmp">
                  <div class="d-flex">
                  <a @click="tryAnotherWay()" class="mt-3">Change MFA Method</a>   
                  <div class="IB_tooltip placement-down">
                    <span class="mt-4">
                      <info-icon size="1.5x" class="custom-class"></info-icon>
                    </span>
                    <div class="tooltip_cnt">
                      <p >
                        OTP is required to change MFA method.
                      </p>
                    </div>
                  </div>
                </div>
                  
                </template>
              </div>
            <a v-if="!mfaSettingUp" :style="{ cursor: 'pointer' }" class="access_method mb-3" @click="lostMfa()">Lost access to MFA method?</a>
          </form>
        </div>
      </template>
      <template v-if="authType=='authenticator'">
        <div class="v-modal verification_modal mfa_auth">
          <form @submit.prevent data-vv-scope="verificationForm" @click="otpErrorMsg= ''" >
            <div class="form-container text-center" @click="otpErrorMsg=''">
                <div v-if="qrCodeUrl !=''" class="qr_code"> 
                  <h4>Please scan the QR code.</h4>
                  <img :src="qrCodeUrl" alt="QR Code">
                </div>
        <div class="verification_info"> 
                  <h6>Please Enter OTP</h6>
              </div>
        <div class="otp_filed">
            <otpInput :isDisabled="isDisabled" v-model="otpVal" @input="updateOtpVal" :length="6" :wrapclass="'md:w-1/4'" :isCallFromQrcode="true"  :showLabel="false" :fieldName="'otp'" :cid="'otp'" />
            <input type="hidden" :name="'primaryDocs'" v-validate="'required'"  data-vv-as="Field"  v-model="getOtpVal">
            <span  v-show="errors.has( 'verificationForm'+'.primaryDocs')" class="text-danger text-sm">*OTP is required</span>
          </div>
          <div class="text-danger text-sm formerrors custom_margin" v-show="otpErrorMsg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ otpErrorMsg }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer relative">
                  <figure  class="loader" v-if="loading"> <img src="@/assets/images/main/loader.gif" />  </figure>
                  <!-- <vs-button v-if="mfaSettingUp"  color="success" class="w-full primary-btn mb-2" :disabled="loading" type="filled" @click="validate('authenticator')">Validate</vs-button> -->
                 <!-- <template v-else> -->
                  <!-- primary-btn color="success" -->
                  <vs-button class="" :disabled="loading" type="filled" @click="submitMfa()">Next</vs-button>
               <template v-if="!mfaSettingUp && !fromEditEmp">
                  <div class="d-flex">
                  <a @click="tryAnotherWay()"  class="mt-3">Change MFA Method</a> <div class="IB_tooltip placement-down">
                    <span class="mt-4">
                      <info-icon size="1.5x" class="custom-class"></info-icon>
                    </span>
                    <div class="tooltip_cnt">
                      <p >
                        OTP is required to change MFA method.
                      </p>
                    </div>
                  </div>
                </div>
                </template>
              </div> 
       <a v-if="!mfaSettingUp" :style="{ cursor: 'pointer' }"  class="access_method mb-3" @click="lostMfa()">Lost access to MFA method?</a>
            </form>   
      </div>        
      </template>
      <vs-popup class="holamundo main-popup cls-btn" :title= "popUpTitle" v-if="isReminderSelected" :active.sync="isReminderSelected">
        <i class="manual_close" @click="isReminderSelected=false;"></i>
        <form  @submit.prevent="">
            <div class="form-container">
            <div class="vx-row">
                <div class="vx-col w-full">
                  <p v-if="popUpTitle=='Reminder'">
                    <template v-if="checkProperty(mfaDetails, 'gracePeriodInDays') > 0"> You must setup Multi-Factor Authentication within {{ checkProperty(mfaDetails, 'gracePeriodInDays') }} days </template>
                    <template v-else>It is now mandatory to enable Multi-Factor Authentication as per the policy.</template>
                  </p>
                  <p v-if="popUpTitle == 'Change MFA'">Are you sure you want to change Verification Method.</p>
                  <p v-if="popUpTitle === 'Lost Access to MFA'">
                    <!-- Please contact <strong>{{ $store.getters['common/getcontactEmail'] || 'contact@immibox.com' }}</strong>  -->
                    Please contact <strong>{{ $store.getters['common/getcontactEmail'] || (mfaDetails['contactEmail'] || "contact@paf-i9.com") }}</strong>
                    and request them to disable your current Multi-Factor Authentication. As soon as the Administrator disables your current method, 
                    you will receive an email with instructions to set up your Multi-Factor Authentication again. You may follow the instructions displayed on the screen.
                  </p>
                </div>      
            </div>
            </div>
            <div class="popup-footer relative">
            <vs-button   color="dark"  :class="popUpTitle=='Lost Access to MFA' ? 'save' : 'cancel'" type="filled"  @click="isReminderSelected=false;"> {{ popUpTitle=='Lost Access to MFA' ? 'Ok' : 'Cancel'}} </vs-button>
            <vs-button v-if="popUpTitle === 'Reminder'" color="success" class="save" @click="checkProperty(mfaDetails, 'gracePeriodInDays') > 0 ? submitMfa(true) : isReminderSelected = false">Ok</vs-button>
            <vs-button  v-if="popUpTitle=='Change MFA'" color="success" class="save"  @click="changeMfaMethod()" >Yes</vs-button>
            </div>
        </form>
      </vs-popup>
    <p v-if="!fromEditEmp" class="signup_text mt-2">
      Go back to <span class="auth-login" @click="goToLogin">Login</span>
    </p>
    </div>       
  </template>
    
  <script>
  import otpInput from "@/views/forms/fields/otpInputNew.vue";
  import QRCode from 'qrcode';
  import src from "vue-phone-mask-input";
  export default {
    name: 'YourComponentName',
    components: {
      otpInput,
      QRCode
    },
    provide() {
    return {
      parentValidator: this.$validator,
    };
  },
    data() {
      return {
        isLinkDisabled: true,
        qrCodeUrl:'',
        popUpTitle:'',
        // mfaDetails:null,
        iscallForLostMfa:false,
        isReminderSelected:false,
        resendTimer: 30,
        otpErrorMsg:'',
        isResendDisabled: true,
        otpVerificationData:'',
        otpVal:'',
        authType:'options',
        selectedAuthType:'',
        ismfarequired:true,
        isMfaActivated:false,
        loading:false,
        remindMeLater:'remindMeLater',
        otpLength:4,
        mfaSettingUp:false,
        isDisabled:false,
        reminder:true
      };
    },
    methods: {   
  goToLogin(){
        this.$emit('mfaCompleted', 'login');
         this.authType = 'options'
      },
      validate(action){
        this.$validator.validateAll('verificationForm').then(result => {
          if(result){
            let path = '/auth/validate-otp'
            let postData={
              'mfaType':action,
              'code':this.otpVal,
              'detailsId':this.checkProperty(this.mfaDetails, 'detailsId'),
            }
            this.loading = true
            this.$store.dispatch("commonAction", {"data":postData, "path":path})
            .then((response)=>{
              this.showToster({message:response.message ,isError:false});
              this.loading = false
              this.mfaSettingUp=false
              this.isDisabled=true
            }).catch((error)=>{
              this.showToster({message:error ,isError:true});
              this.loading = false
              this.isDisabled=false
            })
      }
    })
      },
      lostMfa(){
        this.popUpTitle='Lost Access to MFA'
        this.isReminderSelected=true
      },
      sendOtpMessage(){
        let path = '/auth/send-otp'
        let postData={
          'detailsId':this.checkProperty(this.mfaDetails, 'detailsId'),
        }
        this.$store.dispatch("commonAction", { "data": postData, "path": path }).then((response)=>{
          if(response) {
            this.showToster({message:response.message ,isError:false});
          }
        }).catch((error)=>{
          // this.showToster({message:error ,isError:true});
        })
      },
      changeMfaMethod(){
          let path = '/auth/setup-2fa'
          let postData={
            'detailsId':this.checkProperty(this.mfaDetails, 'detailsId'),
            'code':this.otpVal
          }
          this.$store.dispatch("commonAction", { "data": postData, "path": path })
          .then((response) => {
            this.isReminderSelected = false
            this.showToster({message:response.message ,isError:false});
            setTimeout(()=>{
              this.authType = "options"
              this.selectedAuthType=''
            })
            this.isDisabled=false
            this.reminder=false
          })
          .catch((error) => { 
            this.showToster({ message: error, isError: true });
            this.isReminderSelected = false
            this.isDisabled=false
            this.reminder=false
          })
      },
      selectMfaMethod(){
        this.$validator.validateAll('requestForm').then(result => {
      if(result){
        let path = '/auth/setup-2fa'
        let postData={
          'detailsId':this.checkProperty(this.mfaDetails, 'detailsId'),
          'mfaType':this.selectedAuthType
        }
        this.$store.dispatch("commonAction", { "data": postData, "path": path })
        .then((response)=>{
          if(response){
            console.log(response)
            this.authType = this.selectedAuthType
            if(this.authType == 'email'){
              this.startResendTimer()
              // this.sendOtpMessage()
              this.mfaSettingUp=true
              this.otpLength=4
            }
            if(this.authType=='authenticator'){
              this.mfaSettingUp=true
              this.otpLength=6
              let qrData = response.qrCodeUrl
              this.generateQRCode(qrData);
            }
            
          }
        }).catch((error)=>{
          this.showToster({message:error ,isError:true});
        })
      }
      })
      },
    generateQRCode(text) {
      QRCode.toDataURL(text, { width: 200, margin: 1 }, (error, url) => {
        if (error) {
          console.log('Error generating QR code:', error);
        } else {
          this.qrCodeUrl = url;
        }
      });
    },
  
    setMfaProcess(action){
          this.selectedAuthType=action
          setTimeout(()=>{
            this.selectMfaMethod()
          },200)
      },
      updateOtpVal(data){
          this.otpVerificationData = data
      },
      formatEmail(email) {
          const [localPart, domain] = email.split('@');
          if (localPart.length <= 2) {
              return email; // Not enough characters to mask
          }
          const firstPart = localPart.slice(0, 3);
          const lastPart = localPart.slice(-3);
          const maskedPart = '*'.repeat(localPart.length - firstPart.length - lastPart.length);
          return `${firstPart}${maskedPart}${lastPart}@${domain}`;
      },
      resendOtp(){
        this.sendOtpMessage()
        this.startResendTimer();
    },
    tryAnotherWay(){
      this.$validator.validateAll('verificationForm').then(result => {
          if(result){
            this.popUpTitle='Change MFA'
            this.isReminderSelected=true
          }  
        })
    },
    startResendTimer() {
      this.isResendDisabled = true;
      this.resendTimer = 30;
      this.resendInterval = setInterval(() => {
          if (this.resendTimer > 0) {
          this.resendTimer -= 1;
          } else {
          this.isResendDisabled = false;
          clearInterval(this.resendInterval);
          }
      }, 1000);
  },
     showReminder(action){
        if(action){
            this.popUpTitle='Reminder'
            this.isReminderSelected=true
            this.iscallForLostMfa=true
            this.selectedAuthType=''
        }else{
            this.isReminderSelected=true
          this.selectedAuthType=''
        }
      },
  
    submitMfa(callFromreminder){
      if(callFromreminder){
            this.isReminderSelected=false
            setTimeout(()=>{
              this.$emit('mfaCompleted', this.remindMeLater); 
            },1000)
          }else{
            this.$validator.validateAll('verificationForm').then(result => {
              if(result){
                if(this.mfaSettingUp){
                  let obj = {
                    otpVal : this.otpVal,
                    settingUp:this.mfaSettingUp,
                    mfaType:this.authType
                  }
                  this.$emit('mfaCompleted',obj)
                }else{
                  this.$emit('mfaCompleted', this.otpVal);
                }
              }
            })
          }
       
    },

    },
    watch: {
      mfaValidationMsg(newValue) {
        if (newValue) {
          this.showToster({message:newValue ,isError:true}); 
          this.$store.commit('resetMfaValidation');
        }
      },
      errorMesg(newVal) {
        this.otpErrorMsg = newVal;
      }
    },
      computed:{
          getOtpVal(){
              let returnVal = '';
              let data = this.otpVerificationData;
              let lengthOfData = data.toString().length;
              if(lengthOfData === this.otpLength){
                  returnVal = 'returnVal';
              }
              return returnVal;
          },
          formattedEmail() {
              return this.formatEmail(this.checkProperty(this.mfaDetails, 'email'));
          },
          mfaValidationMsg() {
            return this.$store.state.mfaValidation;
          },
      },
  
    mounted() {
      console.log(this.$store.getters['common/getcontactEmail'])
      if(this.checkProperty(this.mfaDetails, 'mfa') == true){
        if(this.checkProperty(this.mfaDetails, 'mfaType')){
          this.authType = this.mfaDetails['mfaType']
          if(this.authType=='email'){
            this.otpLength=4
            this.sendOtpMessage()
            this.startResendTimer();
          }
          if(this.authType=='authenticator'){
            this.otpLength=6
          }
        }else{
          this.authType='options'
        }
      }
      

    },
    props:{
      mfaDetails:null,
      fromEditEmp: {
          type: Boolean,
          default: false
        },
      errorMesg:''
  },
  };
  </script>
  